<template>
  <c-dialog title-key="document.popup.title"
            close-key="cove.general.close"
            :value="value && loaded"
            :width="800"
            @input="$emit('input', false)"
            simple-close>
    <v-data-table :headers="headers"
                  :items="documents"
                  hide-default-footer
                  must-sort
                  class="elevation-1 ma-3">
      <template slot="item" slot-scope="props">
        <tr>
          <td :data-label="$t('document.popup.name')">{{ props.item.documentName }}</td>
          <td :data-label="$t('document.popup.description')">{{ props.item.documentDescription }}</td>
          <td v-if="props.item.documentAvailable" class="text-right">
            <router-link :to="{ name: 'documentDownload', params: { documentID: props.item.documentID }}"
                         target="_blank">
              {{ $t('document.popup.downloadLink') }}
              <span class="sr-only">
                {{ $t('document.popup.downloadLinkSR') }}
              </span>
            </router-link>
          </td>
          <td v-else class="text-right">
            {{ $t('document.popup.unavailable') }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </c-dialog>
</template>

<script>
export default {
  props: {
    parentId: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.updateData();
      }
      else {
        this.loaded = false;
      }
    }
  },
  data () {
    return {
      documents: [],
      loaded: false
    };
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('document.popup.name'),
          value: 'documentName'
        },
        {
          text: this.$t('document.popup.description'),
          value: 'documentDescription'
        },
        {
          text: this.$t('document.popup.downloadLinkHeader'),
          sortable: false,
          align: 'end'
        }
      ];
    }
  },
  methods: {
    updateData () {
      let url = this.$cove.getAPI({
        name: 'api.publicAccessDocuments',
        query: { filter: 'parentCategory=' + this.category + ',parentID=' + this.parentId }
      });

      this.$axios.get(url).then((response) => {
        this.documents = response.data;
        this.loaded = true;
      });
    }
  }
};
</script>
